import { Button } from '@7f-ui/components/button/button'
import { experienceFormSubject } from '@data-access/lib/gql/data/experience-form-subject'

import Link from 'next/link'

type AppExperienceContactFormLinkProps = {
  experiencePublicId: number
}

export function AppExperienceContactFormLink({
  experiencePublicId,
}: AppExperienceContactFormLinkProps) {
  return (
    <div className="flex w-full flex-col items-start">
      <p className="mb-2 font-base-copy sm:font-body-small">
        Als private Gruppe oder Firma buchen?
      </p>

      <Button
        variant="underline"
        as={Link}
        href={`/service/anfrageformular-erlebnisse/?experienceId=${experiencePublicId}&subject=${experienceFormSubject.PRIVATE_GROUP}`}
      >
        Jetzt Termin anfragen
      </Button>
    </div>
  )
}
